import videojs from 'video.js'
import HlsQualitySelector from 'videojs-hls-quality-selector'

//var videojs = require('video.js');
//require('videojs-contrib-quality-levels');
//require('videojs-hls-quality-selector');

export function createPlayer(el: any, id: string) {
//    console.log(id);
    try {
        //var player = el.player;
        var player = videojs(el);
//        console.log(videojs.getPlayers());
        /*
        player.hlsQualitySelector({
            displayCurrentQuality: true,
            placementIndex: 1,
        });
        */
//        console.log("Loaded");
        var quality = new HlsQualitySelector(player, { displayCurrentQuality: true });
        //player.hlsQualitySelector({ displayCurrentQuality: true });
        return player;
    }
    catch (e) {
        console.log(e);
        return null;
    }
    
}
